import EventEmitter from 'events';

export default class Transcriber extends EventEmitter {
  track = null;
  trackId = null;
  recognition = null;
  recognizing = false;
  transcripts = [];
  startTime = 0;
  endTime = 0;
  currentStamp = 0;

  constructor(track, lang = navigator.language) {
    super();

    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = lang;
      this.track = track;

      this.recognition.onstart = this.emit('start');

      this.recognition.onend = () => this.emit('end');

      this.recognition.onresult = (event) => {
        const { results, resultIndex: i } = event;
        let interimTranscript = '';

        if (results[i].isFinal && results[i][0].transcript) {
          const data = {
            sentence: results[i][0].transcript,
            confidence: results[i][0].confidence,
            timeStamp: this.currentStamp,
            endTimeStamp: new Date().getTime()
          };

          this.transcripts.push(data);

          this.emit('sentence', data);
        } else {
          this.currentStamp = new Date().getTime();
          interimTranscript += results[i][0].transcript;

          this.emit('interim', {
            sentence: interimTranscript,
            timeStamp: this.currentStamp
          });
        }

        this.emit('result', event);
      };
    }
  }

  start = () => {
    this.recognition.start();
    this.recognition.stream = this.track;
    this.recognizing = true;
    this.startTime = performance.now();
    return this;
  };

  stop = () => {
    this.recognition.stop();
    this.recognizing = false;
    this.endTime = performance.now();
    return this;
  };
}
